import { useEffect } from 'react';

import { throttle as throttleFn } from 'lodash-es';

import { Nullable } from '@/utils/globalTypes';

export type UseEvent = {
  name: keyof HTMLElementEventMap;
  handler: EventListener;
  target: Nullable<HTMLElement | Document | Window>;
  options?: boolean | AddEventListenerOptions;
  /**
   * Throttle time for events, it’s disabled by default.
   *
   * @default undefined
   */
  throttle?: number | undefined;
};

const useEvent = ({ name, handler, target, options, throttle }: UseEvent) => {
  useEffect(() => {
    if (!handler || !target) return;

    target.addEventListener(
      name,
      throttle ? throttleFn(handler, throttle) : handler,
      options,
    );

    return () => {
      target.removeEventListener(name, handler, options);
    };
  }, [name, handler, target, options, throttle]);
};

export default useEvent;
